import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import colorSharp2 from "../assets/img/color-sharp2.png";
import TrackVisibility from 'react-on-screen';
import "./Certificates.css";

export const Certificates = () => {
  const certificates = [
    {
      title: "Cloud Computing",
      org: "NPTEL (IIT Kharagpur)",
      date: "April 2024",
      link: "https://archive.nptel.ac.in/content/noc/NOC25/SEM1/Ecertificates/106/noc25-cs11/Course/NPTEL25CS11S153730238604247790.pdf"
    },
    {
      title: "The Bits and Bytes of Computer Networking",
      org: "Coursera",
      date: "April 2024",
      link: "https://www.coursera.org/account/accomplishments/verify/F4VMCAMY14E2"
    },
    {
      title: "Peer-to-Peer Protocols and Local Area Network",
      org: "Coursera",
      date: "April 2024",
      link: "https://www.coursera.org/account/accomplishments/verify/UL0PB5P6GFWV"
    }
  ];

  return (
    <section className="certificates" id="certificates">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Certifications</h2>
                <p className="cert-subtitle">Continuous learning and professional certifications to stay ahead in modern tech ecosystems.</p>
                <div className="cert-grid">
                  {certificates.map((cert, index) => (
                    <div className="cert-card" key={index}>
                      <div className="cert-content">
                        <h4>{cert.title}</h4>
                        <span className="cert-org">{cert.org}</span>
                        <span className="cert-date">{cert.date}</span>
                        <a href={cert.link} target="_blank" rel="noreferrer" className="cert-link">
                          Verify Credential <ArrowRightCircle size={20} />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background glow"></img>
    </section>
  )
}
